// DASH-262: why the captive portal sent the user back. The router's error
// page (portal bundle, see portal-bundle/README.md) adds ?reason= when
// RADIUS refused a voucher with one of these messages.
export const USED_UP = 'used_up';
export const IN_USE = 'in_use';

// Owner's final wording.
export const NOTICE_TEXT = {
  [USED_UP]: 'Your plan has been used up. Buy a new voucher to continue.',
  [IN_USE]: 'This voucher is in use on another device.',
};

// RADIUS Reply-Message texts (freeradius-docker-postgres docker/radius2/default),
// compared without a final full stop. Any other text shows nothing.
const REPLY_TO_NOTICE = {
  'your plan has been used up. buy a new voucher to continue': USED_UP,
  'this voucher is in use on another device': IN_USE,
};

const normalise = (text) => text.trim().replace(/\.$/, '').toLowerCase();

export const noticeFromSearch = (search) => {
  const query = new URLSearchParams(search || '');
  const reason = query.get('reason');
  if (reason === USED_UP || reason === IN_USE) return reason;
  const reply = query.get('reply');
  if (reply) {
    // The "in use" message may go on with the voucher and the other device
    // ("... another device. Voucher: X. Device: Y."), so match its first sentence.
    const text = normalise(reply);
    const known = Object.keys(REPLY_TO_NOTICE).find((key) => text === key || text.startsWith(key + '. '));
    return known ? REPLY_TO_NOTICE[known] : null;
  }
  return null;
};
